import { render, staticRenderFns } from "./matrixScoreChart.vue?vue&type=template&id=34b3cb02&scoped=true&"
import script from "./matrixScoreChart.vue?vue&type=script&lang=js&"
export * from "./matrixScoreChart.vue?vue&type=script&lang=js&"
import style0 from "./matrixScoreChart.vue?vue&type=style&index=0&id=34b3cb02&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b3cb02",
  null
  
)

export default component.exports